module.exports = __webpack_public_path__ + "static/media/videolaranja.6d144278.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/videolaranja.svg
// module id = 162
// module chunks = 0